import SpecialtyFileUploadSection from 'components/SpecialtyFileUploadSection';
import { SPECIALTY_FILE_TYPES } from 'constants/fileTypes';

interface SpecialtyLOAUploadProps {
  isLocked?: boolean;
}

const SpecialtyLOAUpload = ({ isLocked = false }: SpecialtyLOAUploadProps) => {
  return (
    <>
      <SpecialtyFileUploadSection
        title="Prior Declaration (Deck) Page"
        fieldLabel="Prior Policy Declaration Page"
        fileType="prior_policy_declaration"
        fileTypeId={SPECIALTY_FILE_TYPES.PRIOR_POLICY_DECLARATION_PAGES}
        badgeText="Prior Deck Page"
        acceptedFileTypes=".pdf,.eml,.msg"
        infoAlertText="<strong>Required:</strong> Please upload the prior policy declaration page from the previous broker."
        sectionId="sectionSpecialtyLOAPriorDeclaration"
        isLocked={isLocked}
      />

      <SpecialtyFileUploadSection
        title="Current Declaration (Deck) Page"
        fieldLabel="Current Policy Declaration Page"
        fileType="declaration"
        fileTypeId={SPECIALTY_FILE_TYPES.DECLARATION_PAGES}
        badgeText="Current Deck Page"
        acceptedFileTypes=".pdf,.eml,.msg"
        infoAlertText="<strong>Required:</strong> Please upload the current policy declaration page."
        sectionId="sectionSpecialtyLOACurrentDeclaration"
        isLocked={isLocked}
      />

      <SpecialtyFileUploadSection
        title="Signed LOA Document"
        fieldLabel="Signed Letter of Authorization"
        fileType="loa_signed_document"
        fileTypeId={SPECIALTY_FILE_TYPES.LOA_SIGNED_DOCUMENT}
        badgeText="Signed LOA"
        acceptedFileTypes=".pdf,.eml,.msg"
        infoAlertText="<strong>Required:</strong> Please upload the signed Letter of Authorization document."
        sectionId="sectionSpecialtyLOASignedDocument"
        isLocked={isLocked}
      />
    </>
  );
};

export default SpecialtyLOAUpload;
